<template>
  <span class="d-flex justify-content-between align-items-center w-100">
    <span
      class="question-text-wrapper position-relative text-left"
      :class="{ 'text-muted': option.has_user_option && !userOptionChanged && !isActive }"
    >
      {{ option.name }}
      <span
        v-if="showResults && !option.has_user_option && !isQuestionTypeFreeText"
        class="count-indicator"
        data-test="count-indicator"
        data-cy="count-indicator"
      >
        <span class="sr-only">{{ $t('survey.voting.votes') }}</span>
        <span aria-hidden="true">•</span>
        {{ option.count || 0 }}
      </span>
    </span>

    <span class="question-right-wrapper d-flex align-items-center">
      <sdui-icon
        v-if="disabled && isActive"
        class="icon-check-o icon-28"
        data-test="survey-option-icon-check"
        :class="{ 'pl-3': showResults && !option.has_user_option }"
      />

      <sdui-icon v-if="option.has_user_option && userOptionChanged" class="icon-edit-16 primary-when-active" />

      <span
        v-else-if="showResults && !option.has_user_option && !isQuestionTypeFreeText"
        class="percent-indicator pl-1"
        data-cy="percentage-indicator"
      >
        {{ roundedPercentage }}%
      </span>
    </span>

    <SProgress
      v-model="progressValue"
      class="survey-option-progress w-100 h-100 position-absolute"
      :label="$t('survey.voting.votes')"
      :max="100"
      variant="secondary"
      data-test="survey-option-progress"
      aria-hidden="true"
      tabindex="-1"
    />
  </span>
</template>

<script>
import SProgress from 'src/components/base/SProgress.vue'

export default {
  name: 'SduiSurveyOptionContent',

  components: { SProgress },
  props: {
    option: {
      type: Object,
      default: () => ({}),
    },

    isActive: {
      type: Boolean,
      default: false,
    },

    showResults: {
      type: Boolean,
      default: false,
    },

    isQuestionTypeFreeText: {
      type: Boolean,
      default: false,
    },

    isMultipleAnswerable: {
      type: Boolean,
      default: false,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    userOptionChanged: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    progressValue() {
      if (!this.showResults) return 0
      if (this.isQuestionTypeFreeText && this.option.is_chosen) return 100
      return Number(this.option.percentage)
    },

    roundedPercentage() {
      if (!this.option?.percentage) return 0
      return this.option.percentage.toFixed()
    },
  },
}
</script>

<style scoped lang="scss">
.question-text-wrapper,
.question-right-wrapper {
  z-index: 1;
  font-size: pxtorem(15);
}

.count-indicator {
  min-width: 25px;
}

.percent-indicator {
  overflow: hidden;
  height: 100%;
}

.survey-option-progress {
  top: 0;
  left: 0;
  background: transparent;
  border-radius: 8px;

  :deep(.s-progress-bar) {
    background-color: $color-secondary;
    transition: 0.5s cubic-bezier(0.5, 2, 0.7, 0.6);
  }
}
</style>
